import { DropTarget } from 'react-dnd'
import React, { Component } from 'react';
import deleteIcon from '../../images/delete.svg';

const Types = {
	ITEM: 'product-remove'
}

const itemTarget = {

	hover(props) {
	},

	drop(props) {
		props.dropToRemoveSingleRendered(props.appState.draggingProduct);
	},

	canDrop(props, monitor) {
		// Check when to return
		return true
	}
};

const collect = (connect, monitor) => {
	return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver().valueOf(),
		canDrop: monitor.canDrop(),
		getItem: monitor.getItem(),
	}
}

class DropProduct extends Component {
	// This will highlight the unavailable stuff
	// ${isDragging && !canDrop ? 'unavailable' : ''}
	render() {
		const { isOver, canDrop, details } = this.props;

		const { connectDropTarget } = this.props;
		return connectDropTarget(
			<div className={`drop-to-remove ${this.props.visible ? 'visible' : 'hidden'} ${isOver ? 'is-over': ''}`}>
				<img src={deleteIcon} alt="Remove" />
				<p>Drag here to remove this module</p>
			</div>
		)
	}
}
export default DropTarget(Types.ITEM, itemTarget, collect)(DropProduct)